import { Link } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { catchButtonDisplayEvent, catchEditPickupPersonButtonPress, } from '../../../utils/edit-pickup-person/analytics';
import { EditPickupPersonDrawer } from './EditPickupPersonDrawer';
import { useEditPickupPersonContext } from '../../../hooks/useContexts';
export var EditPickupPerson = function (_a) {
    var setPickupPersonState = _a.setPickupPersonState, setPickupPersonFraudError = _a.setPickupPersonFraudError;
    var setOpenPickupPersonDrawer = useEditPickupPersonContext().setOpenPickupPersonDrawer;
    useEffect(function () {
        catchButtonDisplayEvent();
    }, []);
    var handleButtonClick = function () {
        setOpenPickupPersonDrawer(true);
        catchEditPickupPersonButtonPress();
    };
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Link, { component: "button", variant: "body-base", onClick: function () { return handleButtonClick(); } }, "Edit"),
        React.createElement(EditPickupPersonDrawer, { setPickupPersonState: setPickupPersonState, setPickupPersonFraudError: setPickupPersonFraudError })));
};
